import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Sat Sep 11 2018
 * @author LZe
 */
import * as React from 'react';
import CellEditor from './CellEditor';
import { CheckBoxValidated } from '../../../../inputs/CheckBox';
/**
 * CheckBox editor for the AgGrid
 * @extends CellEditor
 */

var CheckBoxEditor =
/*#__PURE__*/
function (_CellEditor) {
  _inherits(CheckBoxEditor, _CellEditor);

  function CheckBoxEditor(props) {
    var _this;

    _classCallCheck(this, CheckBoxEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckBoxEditor).call(this, props));
    /**
     * Handles changes of the checkbox element
     */

    _this.onChange = function (event) {
      _this.updateValue(event.target.checked);
    };

    _this.render = function () {
      return React.createElement("div", {
        ref: _this.wrapper
      }, React.createElement(CheckBoxValidated, {
        validationError: _this.state.validationError,
        name: "test",
        checked: _this.state.value,
        onChange: _this.onChange
      }));
    };

    return _this;
  }

  return CheckBoxEditor;
}(CellEditor);

export { CheckBoxEditor as default };